import Container from '@componentPrimitives/Container';
import Grid from '@componentPrimitives/Grid';
import Breadcrumbs from '@components/Breadcrumbs';
import { Entry, isEntry } from '@lib/features/entries';
import { useGlobalColorTheme } from '@lib/store';
import Box from '@primitive/Box';
import { EntrySummary } from './EntrySummary';
import { PageHeaderProps } from './PageHeader';
import { PageTitle } from './PageTitle';

export const PageHeaderEventIndex = ({
  view,
}: PageHeaderProps<Entry<'eventIndex' | 'ticketIndex'>>) => {
  const globalColorTheme = useGlobalColorTheme();

  const isTicketIndex = isEntry(view, 'ticketIndex');

  return (
    <Box
      as="header"
      colorTheme={isTicketIndex ? 'default' : globalColorTheme}
      colorSet="paper"
      paper>
      <Container cx={{ pY: '2xl' }}>
        <Grid>
          <Grid.Col lg={7} cx={{ display: 'flex', spacing: 'lg', flexDirection: 'column' }}>
            <Breadcrumbs />
            <PageTitle view={view} />
            <EntrySummary />
          </Grid.Col>
        </Grid>
      </Container>
    </Box>
  );
};
